import { useEffect } from 'react';
import useFireClientEvent from './useFireClientEvent';
/**
 * Fires `input_required` if the boolean passed in is true.
 * If no boolean is passed in, it defaults to firing during component load.
 */
export default function useInputRequired(shouldFire) {
    if (shouldFire === void 0) { shouldFire = true; }
    var fireClientEvent = useFireClientEvent();
    useEffect(function () {
        if (shouldFire)
            fireClientEvent('input_required');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldFire]);
}
